import { useIsMobile } from 'pricing-pages-ui-components/hooks/useMedia';
import SuiteProductLevelIdentifiersMap from '../../../../constants/merchCards/SuiteProductLevelIdentifiersMap';
import { SUITE_CARD } from '../../../../constants/tracking/TrackingSources';
import { useGlobalLoading } from '../../../../hooks/loadingHooks';
import { useAppSelector } from '../../../../reducers';
import { isUngatedForInbound25Selector } from '../../../../selectors/GatingSelectors';
import { useFTS0017orFTS0018ExperimentEffect } from '../../../../utils/experiments/fts0017_fts0018';
import { MerchCardLayoutUI } from '../../../../v2/components/MerchCardLayoutUI';
import SkeletonLoadWrapper from '../../../common/loading/SkeletonLoadWrapper';
import { SuiteFeatures } from '../../features-display/SuiteFeatures';
import { CrmSuitePriceMerchCard } from '../../price-display/CrmSuitePriceMerchCard';
import { useCrmSuiteBundleSkuId } from '../../price-display/useCrmSuitePricingInfo';
import { IncludedSeatsDisplayContainerV1 } from '../../seats-display/IncludedSeatsDisplayContainerV1';
import { useShowPricePerMonthPerSeat } from '../../seats-display/useSeatsDisplay';
import { SuiteCardCTAs } from './SuiteCardCTAs';
import { SuiteCardSubheading } from './SuiteCardSubheading';
import { SuiteCardTerm } from './SuiteCardTerm';
import { SuiteCardTitle } from './SuiteCardTitle';
import { jsx as _jsx } from "react/jsx-runtime";
const TRACKING_SOURCE = SUITE_CARD;

// This is used as the merch card for the customer platform routes
export const StandardSuiteCard = ({
  productLevel,
  screen,
  columnStart
}) => {
  const isAppReady = useGlobalLoading();
  const isUngatedForInbound25 = useAppSelector(isUngatedForInbound25Selector);
  const isMobile = useIsMobile();
  const suiteSkuId = useCrmSuiteBundleSkuId({
    productLevel
  });
  const showPricePerMonthPerSeat = useShowPricePerMonthPerSeat({
    skuId: suiteSkuId
  });
  const {
    loading: isLoadingFTS0017AndFTS0018Experiment,
    variant: isInFTS0017AndFTS0018ExperimentVariant
  } = useFTS0017orFTS0018ExperimentEffect();
  const showProductLevelTitle = isInFTS0017AndFTS0018ExperimentVariant && !isLoadingFTS0017AndFTS0018Experiment && screen !== 'crm';
  const SubHeading = /*#__PURE__*/_jsx(SuiteCardSubheading, {
    productLevel: productLevel
  });
  const Seats = /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
    isLoading: !isAppReady,
    heights: [20],
    widths: [140],
    children: suiteSkuId ? /*#__PURE__*/_jsx(IncludedSeatsDisplayContainerV1, {
      skuId: suiteSkuId
    }) : null
  });
  const Features = /*#__PURE__*/_jsx(SuiteFeatures, {
    productLevel: productLevel,
    loading: !isAppReady,
    isCollapsible: isMobile
  });
  return /*#__PURE__*/_jsx(MerchCardLayoutUI, {
    "data-test-id": `${SuiteProductLevelIdentifiersMap[productLevel]}-merch-card`,
    "data-selenium-id": `${SuiteProductLevelIdentifiersMap[productLevel]}-merch-card`,
    columnStart: columnStart,
    Title: /*#__PURE__*/_jsx(SuiteCardTitle, {
      productLevel: productLevel,
      showProductLevelTitle: showProductLevelTitle
    }),
    Subheading: SubHeading || null,
    Pricing: /*#__PURE__*/_jsx(CrmSuitePriceMerchCard, {
      productLevel: productLevel,
      showPricePerMonthPerSeat: showPricePerMonthPerSeat
    }),
    Seats: Seats,
    Term: /*#__PURE__*/_jsx(SuiteCardTerm, {
      productLevel: productLevel,
      trackingSource: TRACKING_SOURCE
    }),
    CTAs: /*#__PURE__*/_jsx(SuiteCardCTAs, {
      productLevel: productLevel,
      screen: screen,
      trackingSource: TRACKING_SOURCE
    }),
    Features: Features,
    isUngatedForInbound25: isUngatedForInbound25
  });
};